export default __webpack_public_path__ + "static/media/error.f5b2fbca.svg";